import { createContext } from "react";
import EUnityWindow from "./EUnityWindows";

export default createContext(EUnityWindow);
